__turbopack_context__.v({
  "canadianBrand": "BuyCanadian-module-scss-module__0LFBfW__canadianBrand",
  "container": "BuyCanadian-module-scss-module__0LFBfW__container",
  "mapleLeafIcon": "BuyCanadian-module-scss-module__0LFBfW__mapleLeafIcon",
  "tooltip": "BuyCanadian-module-scss-module__0LFBfW__tooltip",
  "tooltipButton": "BuyCanadian-module-scss-module__0LFBfW__tooltipButton",
});
